import { groupForecastRoutes } from './views/groupForecaster/routes';
import OptimizerPro from './OptimizerPro.vue';
import OptimizerProView from './views/OptimizerProView.vue';
import { priceManagerRoutes } from './views/priceManager/routes';
import { menuManagerRoutes } from './views/menuManager/routes';

export const optimizerProRoutes = [
  {
    path: 'optimizer-pro',
    component: OptimizerPro,
    children: [
      ...groupForecastRoutes,
      ...priceManagerRoutes,
      ...menuManagerRoutes,
      { path: '', component: OptimizerProView, name: 'optimizer-pro' }
    ]
  }
];
